<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasCustomer="true"
      :hasAdd="true"
      :hasEdit="true"
      :hasRemove="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :items="receipts"
      :pagination="pagination"
      :columns="columns"
      @addItem="add"
      @editItem="edit"
      @removeItem="remove"
      :nameProperty="nameProperty"
      :getTrigger="getTrigger"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      receipts: [],
      pagination: {},
      columns: [
        {
          name: "ReceiptNumber",
        },
        {
          name: "ReceiptDate",
        },
        {
          name: "CustomerNumber",
        },
        {
          name: "CustomerName",
        },
        {
          name: "Total",
        },
        {
          name: "Memo",
        },
      ],
      nameProperty: "ReceivableNumber",
      getTrigger: false,
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    getItems(condition) {
      const vm = this;
      this.$api.receipts.getPages(condition).then((data) => {
        vm.receipts = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
    downloadExcel(condition) {
      this.$api.reportExcels.getReceipt(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getReceipt(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printReceipt(condition);
    },
    add() {
      this.$router.push({ name: "ReceiptAdd" });
    },
    edit(item) {
      this.$router.push({
        name: "ReceiptEdit",
        params: { id: item.ReceiptId },
      });
    },
    remove(item) {
      const vm = this;
      this.$api.receipts.delete(item.ReceiptId).then(() => {
        vm.getTrigger = !vm.getTrigger;
      });
    },
  },
};
</script>
